module.exports = __webpack_public_path__ + "img/pd-img-head7.95f116c7.png";